module.exports = __webpack_public_path__ + "static/media/videoCard.09033a74.jpg";